import React from 'react';
import { useView } from '../context/ViewContext';

const ViewToggle = () => {
    const { isOwner, viewMode, toggleView } = useView();

    // Only show toggle for owner
    if (!isOwner) return null;

    return (
        <div className="view-toggle">
            <button
                className={`toggle-btn ${viewMode === 'owner' ? 'active' : ''}`}
                onClick={toggleView}
            >
                <span className="toggle-icon">{viewMode === 'owner' ? '👑' : '🏭'}</span>
                <span className="toggle-text">
                    {viewMode === 'owner' ? 'Owner View' : 'Manufacturer View'}
                </span>
                <span className="toggle-switch">
                    Switch
                </span>
            </button>
        </div>
    );
};

export default ViewToggle;
